import { Store } from "backend/storage/app.store";
import { appConfig } from "config/initializers/config.app";
import _ from "lodash";

export const getAppConfig = () => {
    const initalState = appConfig;
    let storeState = {};
    if (
        Store.getState().auth.user &&
        Store.getState().auth.user.client &&
        Store.getState().auth.user.client.appConfiguration
    ) {
        storeState =
            Store.getState().auth.user.client.appConfiguration || {};
    }
    const result = _.merge(initalState, storeState);
    return result;
};



// WEBPACK FOOTER //
// ./src/config/client.config.js